export enum SignalrMethodName {
  validate = 'validate',
  saveUploadedProducts = 'SaveUploadedProducts',
  itemizeSet = 'ItemizeSet',
  updateQuotePricing = 'UpdateQuotePricing',
  editQuote = 'EditQuote',
  startGoOnlineSync = 'StartGoOnlineSync',
  receiveOnlineUpdates = 'ReceiveOnlineUpdates',
  importQuotesOrOrders = 'ImportQuotesOrOrders',
  generateQuote = 'GenerateQuote'
}
